<template>
	<div :class="{'has-error': mensagemErro}">
		<label> <span v-if="obrigatorio">*</span> {{ label }}: </label>
		<select
			:disabled="disabled"
			:value="value"
			@input="$emit('input', $event.target.value)"
			@change="$emit('change', $event.target.value)"
			class="form-control input-sm"
		>
			<option value="">{{ this._traducao('global', opcaoDefault).toUpperCase() }}</option>
			<option v-for="opcao in listaOpcoes" :key="opcao.value" :value="opcao.value">
				{{ opcao.label ? opcao.label.toUpperCase() : '' }}
			</option>
		</select>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},

		opcoes: {
			type: Array,
			required: false,
			default: function () {
				return []
			}
		},

		opcoesObjeto: {
			type: Array,
			required: false,
			default: function () {
				return []
			}
		},

		opcaoDefault: {
			required: false,
			default: 'escolha',
			type: String
		},

		value: {
			required: false,
			default: ''
		},

		mensagemErro: {
			type: String,
			required: false,
			default: ''
		},

		obrigatorio: {
			type: Boolean,
			required: false,
			default: false
		},

		disabled: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		listaOpcoes() {
			let retorno = []
			if (this.opcoesObjeto.length > 0) {
				retorno = this.opcoesObjeto
			} else {
				retorno = this.opcoes.map((opcao) => {
					return {
						label: opcao,
						value: opcao
					}
				})
			}

			this.$forceUpdate()

			return retorno
		}
	}
}
</script>